import { Document, Page, StyleSheet, Text, View, Image, pdf } from '@react-pdf/renderer'
import { isArray } from 'lodash'
import { PTKPI } from '../../shared/model'

const styles = StyleSheet.create({
  header: {
    width: '100%',
    marginBottom: 60,
  },
  bodyText: {
    fontFamily: 'Raleway',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 0,
    textAlign: 'justify',
  },
  bodyTextBold: {
    fontFamily: 'RalewayBold',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 0,
  },
})

export const downloadKPIsAsPDF = async (
  ptKPIs: PTKPI[],
  year: number,
  lang: string,
  theme: any,
  t: any,
) => {
  const Template = (
    <Document>
      <Page size="A4" dpi={150} style={{ padding: 60 }}>
        <View style={styles.header}>
          <Text style={{ ...styles.bodyTextBold, fontSize: 24 }}>{t('etrl.kpi.title')}</Text>
          <View
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 8 }}
          >
            <Text style={styles.bodyTextBold}>{`${t('etrl.kpi.date')}: `}</Text>
            <Text style={styles.bodyTextBold}>{year}</Text>
          </View>
        </View>
        {ptKPIs.map((type: any) => {
          return type.sections.map((section: any) => {
            const { id, results, law, title, info } = section
            let valueHeaders: string[] = []
            if (results[0] && isArray(results[0].value)) {
              valueHeaders = results[0].value.map((v: any) => t(`etrl.kpi.${v.label}`))
            }
            return results.length > 0 ? (
              <View>
                <View
                  key={`type_${type.id}_section_${id}`}
                  wrap={false}
                  style={{
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: theme.palette.secondary.main,
                    borderRadius: 8,
                    marginBottom: 16,
                  }}
                >
                  <View
                    style={{
                      backgroundColor: theme.palette.secondary.light,
                      padding: 16,
                      borderTopLeftRadius: 8,
                      borderTopRightRadius: 8,
                    }}
                  >
                    <Text style={{ ...styles.bodyText, fontSize: 12 }}>{law}</Text>
                    <Text style={{ ...styles.bodyText, marginTop: 4 }}>{title.text[lang]}</Text>
                  </View>
                  <View style={{ padding: 8 }}>
                    {valueHeaders.length > 0 ? (
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingHorizontal: 16,
                        }}
                      >
                        <Text style={{ ...styles.bodyTextBold, fontSize: 14 }}>
                          {law === 'Abs. 1 Ziff. 7 (EU Art. 9, 1. g)'
                            ? t('Comparable Worth Index (CWI)')
                            : ''}
                        </Text>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                          }}
                        >
                          {valueHeaders.map((vh, vhIndex) => (
                            <Text
                              key={`type_${type.id}_section_${id}_${vhIndex}`}
                              style={{
                                ...styles.bodyTextBold,
                                fontSize: 12,
                                width: '155px',
                                textAlign: 'center',
                              }}
                            >
                              {vh}
                            </Text>
                          ))}
                        </View>
                      </View>
                    ) : null}
                    {results.map(({ label, value }: any, index: number) => (
                      <View
                        key={`type_${type.id}_section_${id}_${index}`}
                        style={{
                          flexDirection: 'row',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginVertical: 4,
                          backgroundColor: theme.palette.action.hover,
                          borderRadius: 4,
                          padding: 16,
                        }}
                      >
                        <Text style={styles.bodyText}>{t(label.text)}</Text>

                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                          }}
                        >
                          {isArray(value) ? (
                            value.map((val, vIndex) => (
                              <View
                                key={`res_${index}_val_${vIndex}`}
                                style={{ borderLeft: 4, borderColor: 'white', height: '100%' }}
                              >
                                <Text
                                  style={{
                                    ...styles.bodyTextBold,
                                    width: '150px',
                                    textAlign: 'center',
                                    color:
                                      law === 'Abs. 1 Ziff. 7 (EU Art. 9, 1. g)' &&
                                      vIndex === 0 &&
                                      Number(val.value) > 5
                                        ? '#d32f2f'
                                        : '#000',
                                  }}
                                >
                                  {val.value !== null
                                    ? `${Number(val.value).toLocaleString(lang, {
                                        maximumFractionDigits: 2,
                                      })} %`
                                    : 'NA'}
                                </Text>
                              </View>
                            ))
                          ) : (
                            <View
                              key={`res_${index}_val`}
                              style={{ borderLeft: 4, borderColor: 'white', height: '100%' }}
                            >
                              <Text
                                style={{
                                  ...styles.bodyTextBold,
                                  width: '140px',
                                  textAlign: 'center',
                                }}
                              >
                                {value !== null
                                  ? `${Number(value).toLocaleString(lang, {
                                      maximumFractionDigits: 2,
                                    })} %`
                                  : 'NA'}
                              </Text>
                            </View>
                          )}
                        </View>
                      </View>
                    ))}
                  </View>
                </View>
                {law === 'Abs. 1 Ziff. 7 (EU Art. 9, 1. g)' ? (
                  <View style={{ marginTop: 16 }}>
                    <View>
                      <Text
                        style={{
                          ...styles.bodyTextBold,
                          marginTop: '16px',
                        }}
                      >
                        {t('etrl.kpi.occ.inc')}
                      </Text>
                    </View>
                    {results.map(({ label }: any) => (
                      <View
                        style={{ marginTop: '24px' }}
                        wrap={false}
                      >
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                          }}
                        >
                          <View style={{ width: '25%' }}>
                            <Text style={{ ...styles.bodyTextBold, marginLeft: '20px' }}>
                              {`${t('ofa.header.cwi')}: ${parseInt(label.text, 10)}`}
                            </Text>
                          </View>
                          <View style={{ width: '75%', marginLeft: '8px' }}>
                            <Text style={styles.bodyTextBold}> </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            marginTop: '16px',
                            width: '100%',
                          }}
                        >
                          <View style={{ width: '17%', textAlign: 'center' }}>
                            <Text style={{ ...styles.bodyTextBold, textAlign: 'center' }}>
                              {t('pt.assistance.selected.occ.kldb')}
                            </Text>
                          </View>
                          <View style={{ width: '83%', marginLeft: '8px' }}>
                            <Text style={styles.bodyTextBold}>
                              {t('pt.assistance.selected.occ.main')}
                            </Text>
                          </View>
                        </View>
                        {label.tooltipText.map((vv: any) => (
                          <View
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start',
                              width: '100%',
                              marginTop: '8px',
                            }}
                          >
                            <View style={{ width: '17%', textAlign: 'center' }}>
                              <Text style={{ ...styles.bodyText, textAlign: 'center' }}>
                                {vv.kldb20105}
                              </Text>
                            </View>
                            <View style={{ width: '83%', marginLeft: '8px' }}>
                              <Text style={styles.bodyText}>
                                {lang === 'de' ? vv.bezeichnungKldb : vv.titleKldb}
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>
                    ))}
                  </View>
                ) : null}
              </View>
            ) : null
          })
        })}
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            position: 'absolute',
            right: 40,
            bottom: 40,
          }}
          fixed
        >
          <Text
            style={{ ...styles.bodyText, fontSize: 12 }}
            render={({ pageNumber, totalPages }) =>
              `${t('page', { lng: lang })} ${pageNumber} / ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  )

  const blob = await pdf(Template).toBlob()

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = data
  link.download = 'Berichtspflichtige_Indikatoren'

  // this is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  )

  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
    link.remove()
  }, 100)

  return null
}
